/**
 * Get the active image for a character based on true form reveal state.
 * When trueFormRevealed is true and a true form image exists, it replaces
 * the profile image everywhere.
 *
 * @param {Object} character - Character document
 * @returns {{ url: string, crop: Object|null }}
 */
export function getActiveImage(character) {
  if (!character) {
    return { url: '', crop: null }
  }

  if (character.trueFormRevealed && character.trueFormImageUrl) {
    return {
      url: character.trueFormImageUrl,
      crop: character.trueFormImageCrop || null,
    }
  }

  return {
    url: character.profileImageUrl || '',
    crop: character.profileImageCrop || null,
  }
}
